// TEH-1606 (F25): экранирование пользовательского ввода перед вставкой в HTML-разметку
export const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

export default escapeHtml
